<template>
  <div class="staffing">
    <el-table :data="tableData" style="width: 100%" class="w100  table">
      <el-table-column label="序号" type="index" width="60">
      </el-table-column>
      <el-table-column label="类别">
        <el-table-column prop="name" label="聘用人员"> </el-table-column>
      </el-table-column>
      <el-table-column label="应发" align="center">
        <el-table-column
          prop="workArrangementDesc"
          label="(聘任)职务层次"
          show-overflow-tooltip
          width="120"
        >
        </el-table-column>
        <el-table-column prop="postGradeDesc" label="岗位等级" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="postPay"
          label="岗位工资"
          show-overflow-tooltip
          width="120"
        >
        </el-table-column>
        <el-table-column prop="gradePay" label="薪级工资" show-overflow-tooltip width="80">
        </el-table-column>
        <el-table-column prop="basePay" label="基础性绩效" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="increasePay" label="教护提高10%" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="agePay" label="教护龄津贴" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="propertyPay" label="物业补贴" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="foodPay" label="伙食补贴" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="otherPay" label="其他" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mustTotal" label="应发合计" show-overflow-tooltip>
        </el-table-column>
      </el-table-column>
      <el-table-column label="应扣" align="center">
        <el-table-column prop="rentPay" label="房租" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="electricPay" label="电费" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="waterPay" label="水费" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="healthPay" label="卫生费" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="pensionPay" label="养老保险8%" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="medicalCarePay" label="医疗保险2%" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="loseJobPay" label="失业保险0.5%" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="accumulationFundPay" label="公积金12%" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="occupationPay" label="职业年金" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="deductTotal" label="扣款合计" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="actualPay" label="实发合计" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="payTime" label="发放日期" show-overflow-tooltip>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props:{
    tableData:{
      default:[],
      require:true
    }
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
  /deep/.el-table {
    width: 100%;
    height: 100%;
    .el-table__body-wrapper {
      max-height: calc(100vh - 300px);
      overflow-y: auto;

    }
  }
</style>